import React, { useState } from 'react';
import { Card, CardBody, Col, Row, Button, Form, Container } from 'reactstrap';
import { useForm } from 'react-hook-form';
import { buttonStyle } from 'layouts/LoginAutoAuth/components/utils';
import { toISOFormat } from '../../../../shared/dataFormater';
import CRMDashboardService from '../../../../service';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import DefaultDashboardFieldsFilterForm from './form/DefaultFieldsFilterForm';

import ProductQuantityChart from './components/ProductQuantityChart';
import ProductSubtotalChart from './components/ProductSubtotalChart';

const MultiCatalogDashboards = () => {
  const { control, handleSubmit, setValue, getValues, register, watch } =
    useForm();
  const systemConfiguration = useSelector((state) => state.systemConfiguration);
  const [productsByStage, setProductsByStage] = useState([]);

  const getDashboardProducts = (params) => {
    CRMDashboardService.getProductsCountByStageWithDate(params)
      .then((response) => {
        const content = response?.data?.data;
        setProductsByStage(content.countProductsAmountByProduct || []);
      })
      .catch((error) => {
        const errorMessage =
          error?.response?.data?.message ||
          error?.message ||
          'Ops, ocorreu um erro!';
        toast.error(errorMessage, {
          autoClose: 3000,
          closeOnClick: true
        });
      });
  };

  const onSubmit = (data) => {
    try {
      let formatedData = {
        ...data,
        dateBegin: `${toISOFormat(data.dateBegin)}`,
        dateEnd: `${toISOFormat(data.dateEnd)}`,
        filterDateBy: data.filterDateBy
      };

      getDashboardProducts(formatedData);
    } catch (err) {
      const errorMessage =
        err?.response?.data?.message || err?.message || 'Ops, ocorreu um erro!';
      toast.error(errorMessage, {
        autoClose: 3000,
        closeOnClick: true
      });
    }
  };

  return (
    <Container className="p-0">
      <Card>
        <CardBody>
          <div>
            <Form
              className="needs-validation"
              onSubmit={handleSubmit(onSubmit)}
            >
              <DefaultDashboardFieldsFilterForm
                setValue={setValue}
                control={control}
                getValues={getValues}
                register={register}
                watch={watch}
              />

              <br />

              <Button
                type="submit"
                style={buttonStyle(systemConfiguration.primary_color)}
                className="mb-2"
              >
                Buscar
              </Button>
            </Form>

            <Row className="mt-4">
              <Col>
                <ProductQuantityChart opportunityData={productsByStage} />
              </Col>
            </Row>

            <Row className="mt-4">
              <Col>
                <ProductSubtotalChart opportunityData={productsByStage} />
              </Col>
            </Row>
          </div>
        </CardBody>
      </Card>
    </Container>
  );
};

export default MultiCatalogDashboards;
